module.exports = __webpack_public_path__ + "img/detail-chapters.657a7d64.svg";